import { api, type PaginatedResponse } from './client';

export interface ChangeDetailOut {
  id: string;
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  old_hash: string | null;
  new_hash: string | null;
  is_pii: boolean;
}

export interface ChangeEventOut {
  id: string;
  table_name: string;
  table_label: string;
  record_id: string;
  action: string;
  actor_id: string | null;
  ip: string | null;
  request_id: string | null;
  created_at: string;
}

export interface ChangeEventWithDetails extends ChangeEventOut {
  details: ChangeDetailOut[];
}

export type ChangeEventListResponse = PaginatedResponse<ChangeEventOut>;

export interface TrackedTable {
  table_name: string;
  label: string;
}

export interface ChangeHistoryQueryParams {
  table?: string;
  record_id?: string;
  action?: string;
  actor_id?: string;
  request_id?: string;
  data_inicio?: string;
  data_fim?: string;
  page?: number;
  page_size?: number;
}

export async function queryChangeHistory(params: ChangeHistoryQueryParams): Promise<ChangeEventListResponse> {
  const { data } = await api.get<ChangeEventListResponse>('/admin/change-history', { params });
  return data;
}

export async function getChangeEventDetails(eventId: string): Promise<ChangeEventWithDetails> {
  const { data } = await api.get<ChangeEventWithDetails>(`/admin/change-history/${eventId}/details`);
  return data;
}

export async function getTrackedTables(): Promise<TrackedTable[]> {
  const { data } = await api.get<TrackedTable[]>('/admin/change-history/tables');
  return data;
}
